/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon24Solid = forwardRef('SendPaperplaneDiagIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18.933 2.741 2.361 7.932c-1.17.367-1.403 1.923-.39 2.615l5.044 3.449a1.47 1.47 0 0 0 1.868-.174l4.421-4.42a.9.9 0 1 1 1.273 1.272l-4.421 4.42a1.47 1.47 0 0 0-.174 1.869l3.441 5.036c.693 1.013 2.248.782 2.615-.39l5.197-16.566c.444-1.415-.886-2.745-2.302-2.302Z" })));
});
